import { createSlice } from '@reduxjs/toolkit';

export interface UserdataModel {
  isAuth: boolean;
  username: string;
  role: string;
  ecommerce?: string;
  comercionombre?: string;
  comerciocodigo?: string;
}

const initialState: UserdataModel = {
  isAuth: false,
  username: '',
  role: '',
};

export const userdataSlice = createSlice({
  name: 'userdata',
  initialState,
  reducers: {
    pushUserdata: (state, action: { payload: UserdataModel }) => ({
      ...state,
      ...action.payload,
    }),
    resetUserdata: () => initialState,
  },
});

export const { pushUserdata, resetUserdata } = userdataSlice.actions;

export default userdataSlice.reducer;
